var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("res-form", {
    attrs: { title: "Resolución Exenta UGDP-S", "type-document": "RESUGDPS" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }